import { useViewerStore } from '../../../../../store/store';

/** Opens inline AI designs on the dashboard (menubar signal); does not open the modal popup. */
export function triggerV3AiDesignsPanel(): void {
    useViewerStore.setState((s) => ({
        designsMenubarSignal: s.designsMenubarSignal + 1,
        designsMenubarTab: 'ai' as const,
    }));
}
